var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { renderOutrightMarkets } from "../LiveOutright";
import * as RenderMethods from "./RenderMethods";
var MiniOutright = /** @class */ (function (_super) {
    __extends(MiniOutright, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function MiniOutright(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOutrightDetails = RenderMethods.renderMiniOutrightDetails;
        _this.renderMarkets = renderOutrightMarkets;
        _this.componentPrefix = "mini-outright";
        _this.buttonsHolderClass = "rj-ev-list__" + _this.componentPrefix + "__buttons-holder";
        return _this;
    }
    MiniOutright.prototype.render = function () {
        var isSelected = this.props.event.isSelected ? "rj-ev-list__" + this.componentPrefix + "--selected" : "";
        return (React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + " " + isSelected, "data-uat": "div-ev-list-" + this.componentPrefix },
            React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + "__inner", "data-uat": "div-ev-list-" + this.componentPrefix + "-inner" },
                this.renderOutrightDetails(this.props.event, this.props.handlers, this.props.isFavoritesEnabled, this.componentPrefix),
                this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix))));
    };
    return MiniOutright;
}(React.Component));
export { MiniOutright };
//# sourceMappingURL=MiniOutright.js.map